import styled from 'styled-components';

export const ReplyColumns = styled.div`
  align-items: ${({ centered }) => (centered ? 'center' : 'flex-start')};
  display: flex;
  padding: ${({ centered }) => (centered ? '0 16px' : '16px 16px 8px 16px')};
`;

export const ReplyColumnAvatar = styled.div`
  flex: 0 0 auto;
  margin-right: 8px;
`;

export const ReplyColumnContent = styled.div`
  flex: 1 1 auto;
  overflow: hidden;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/ReplyColumn.js